export default __webpack_public_path__ + "static/media/EricImage.png.webp";